import React from "react";
import { useAppState } from "hooks/AppContext";
import { ContentModuleBaseAttributes } from "utils/orm";
import QuizConfig from "utils/jobQuizConfig.json";
import JobQuizContainer, { JobQuizContainerProps } from "./JobQuiz/JobQuizContainer";

import articleContainerStyles from "./articleContainer.module.scss";

export interface JobQuizBlock extends ContentModuleBaseAttributes {
}

/**
 * Creates an inline CTA module. This is a content module and is injected in Post process.
 * @example
 * import { SponsorInlineModule } from "components/SponsorInlineModule";
 * <SponsorInlineModule {...MOCK_Sponsor} />
 */
export const JobQuizModule: React.FC<JobQuizBlock> = () => {
    const { article } = useAppState();

    const onQuizSubmit = (responses: any) => {
        const filtersFromResponses: any = [];
        responses.questions.forEach((elem: any) => {
            let answers = "";
            if (elem.response === null) {
                return;
            }

            if (Array.isArray(elem.response)) {
                answers = elem.response.join();
            } else {
                answers = elem.response;
            }
            filtersFromResponses.push(`${elem.field}=${answers}`);
        });
        const searchUrl = `/search?${filtersFromResponses.join("&")}`;
        window.open(searchUrl, "_blank");
    };

    const jobQuizProps: JobQuizContainerProps = {
        ...QuizConfig,
        trackingOverrides: {
            sp_impression_component: "insert",
            sp_impression_insert_type: "job_quiz",
            sp_impression_position: "second_para",
            sp_page_type: "content",
            sp_page_section: "advice",
            sp_page_company_id: null,
            sp_page_tab: null,
            sp_page_is_external: false,
        },
        onSubmit: onQuizSubmit
    };

    const excludedUrls = [
        "interview-questions-and-answers"
    ];

    const excludedCategories = [
        "vibe-awards"
    ];

    const showJobQuiz: boolean = !excludedUrls.includes(article?.slug)
                                 && !excludedCategories.includes(article?.categorySlug)
                                 && !article.sponsor.id;

    return showJobQuiz ? (
        <aside className={`${articleContainerStyles.contentModule}`}>
            <JobQuizContainer {...jobQuizProps} />
        </aside>
    ) : null;
};
